import axios from 'axios';

import {
  CLEAR_PERSISTED_DATA,
  LOGIN_SUCCESS,
  SYSTEM_TOAST_ERROR_MESSAGE,
  SYSTEM_TOAST_SUCCESS_MESSAGE,
  LOGOUT,
  GET_BIRTHDAYS,
  GET_ALL_BIRTHDAYS,
  GET_WEATHER,
  SET_USER,
  GET_USERS,
} from './types';
import { serverEndPoint } from './Utils';

export const authUser = (params) => {
  // @TODO Autenticação Aqui
  return async (dispatch) => {
    try {
      const { data, status } = await axios.post(`${serverEndPoint}/user/authUser`, params);
      if (status === 200 && data?.re_usuario) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Login efetuado!',
        });
        dispatch({
          type: LOGIN_SUCCESS,
          payload: true,
        });
        dispatch({
          type: SET_USER,
          payload: data,
        });
      } else {
        dispatch({
          type: SYSTEM_TOAST_ERROR_MESSAGE,
          payload: 'Dados inválidos',
        });
      }
    } catch (err) {
      console.log(err.response.data.error)

      if (err.response.data.error == 'É necessário realizar o login no comunica') {
        dispatch({
          type: SYSTEM_TOAST_ERROR_MESSAGE,
          payload: 'É necessário realizar o login no comunica',
        });
        return 0;
      } 
      dispatch({
        type: SYSTEM_TOAST_ERROR_MESSAGE,
        payload: 'Erro na autenticação',
      });
    }
  };
};

export const firstAcessChangePassword = (params) => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.post(`${serverEndPoint}/user/firstAcessChangePassword`, params);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Senha Alterada!',
        });
      } else {
        dispatch({
          type: SYSTEM_TOAST_ERROR_MESSAGE,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: SYSTEM_TOAST_ERROR_MESSAGE,
        payload: 'Erro na autenticação',
      });
    }
  };
};

export const userLogout = (params) => {
  return async (dispatch) => {
    dispatch({
      type: LOGOUT,
    });
    dispatch({
      type: CLEAR_PERSISTED_DATA,
    });
  };
};

export const getBirthdays = (params) => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/user/getBirthdays`);
      if (status === 200) {
        let i = 1;
        const birthDays = data.map((b) => {
          let data_aniversario = b?.dt_nascimento.split('-')
          let day = parseInt(data_aniversario[2])
          let month = parseInt(data_aniversario[1])
          return {
            id: i++,
            name: b?.nome.toLowerCase(),
            birthMonth: month,
            birthDate: day,
            birthDay: `${data_aniversario[2]}/${data_aniversario[1]}`,
            ut: b?.nome_coligada?.toLowerCase() || 'Não Consta',
            office: b?.atividade?.toLowerCase() || 'Não Consta',
          };
        });

        const currentDate = new Date();
        const birthDaysOfMonth = birthDays.filter((b) => {
          return (b.birthMonth === currentDate.getMonth() + 1) && (b.birthDate === currentDate.getDate());
        });

        birthDaysOfMonth.sort(() => {
          return 1;
        });

        dispatch({
          type: GET_BIRTHDAYS,
          payload: birthDaysOfMonth,
        });
        dispatch({
          type: GET_ALL_BIRTHDAYS,
          payload: birthDays,
        });
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: SYSTEM_TOAST_ERROR_MESSAGE,
        payload: 'Erro ao recuperar aniversários!',
      });
    }
  };
};

export const getLocaleAndWeather = () => {
  return async (dispatch) => {
    try {

      await navigator.geolocation.getCurrentPosition(async (position) => {
        const weather = await axios.get(
          `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=a83ce98e132c31ba9aae639ce655b13d&lang=pt&units=metric`,
        );
        if (weather?.status === 200) {

          dispatch({
            type: GET_WEATHER,
            payload: {
              locale: weather.data.name,
              temp: weather?.data?.main?.temp.toString().split('.')[0],
              tempIcon: weather?.data?.weather[0]?.main,
            },
          });
        }
      })

    } catch (err) {
      console.log(err);
      dispatch({
        type: SYSTEM_TOAST_ERROR_MESSAGE,
        payload: 'Erro ao recuperar clima!',
      });
    }
  };
};

export const getUsers = (has_log = undefined) => {

  if (has_log) {
    userLogout();
  }

  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/user/getAdmUsers`);
      if (status) {
        dispatch({
          type: GET_USERS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const deleteAdmUserById = (_id) => {
  return async (dispatch) => {
    try {
      const { status, data } = await axios.delete(`${serverEndPoint}/user/deleteAdmUserById/${_id}`);
      if (status) {
        let msg = (data.mensagem) ? data.mensagem : 'Permissão removida!'
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: msg,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const ativarAdmUserById = (_id) => {
  return async (dispatch) => {
    try {
      const { status, data } = await axios.delete(`${serverEndPoint}/user/ativarAdmUserById/${_id}`);
      if (status) {
        let msg = (data.mensagem) ? data.mensagem : 'Permissão Ativa!'
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: msg,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const generateAdmUser = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.post(`${serverEndPoint}/user/generateAdmUser`, params);
      if (status) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Permissão Adicionada!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getUserNotifications = async (id) => {

  if (!id || id === 'NAO INFORMADO' || id === 'NAO%20INFORMADO') {
    return []
  }

  var pushNotifications = []
  try {
    const userNotification = await axios.get(`${serverEndPoint}/user/getUserNotifications/${id}`);
    const aproavaDocuments = await axios.get(`${serverEndPoint}/user/getUserApprovalNotifications/${id}`);
    const myrequests = await axios.get(`${serverEndPoint}/user/getUserFindMyRequests/${id}`);
    const myrequestsGroups = await axios.get(`${serverEndPoint}/user/getNotificationsGroups/${id}`);
    await Promise.all([userNotification, aproavaDocuments, myrequests, myrequestsGroups]).then((notifications) => {
      notifications.map((item) => {
        if (item.status) {
          pushNotifications.push(...item.data)
        }
      })

    }).catch((error) => {
      console.log(error);
      return pushNotifications;
    })

    return pushNotifications;

  } catch (error) {
    console.log(error);
    return pushNotifications;
  }
};

